export const ADMIN_ROUTES = {
  DOCUMENT_VALIDATION: {
    path: "/web/admin/validacion-documentos",
    title: "Validación de documentos",
    code: "document_validation",
  },
  PAYMENT_VALIDATION: {
    path: "/web/admin/validacion-pagos",
    title: "Validación contado",
    code: "payment_validation",
  },
  PAYMENT_RECAUDO: {
    path: "/web/admin/validacion-recaudo",
    title: "Validación recaudo",
    code: "payment_recaudo",
  },
  TURN_CONFIRMATION: {
    path: "/web/admin/creacion-turnos",
    title: "Confirmación de turnos",
    code: "turns_creation",
  },
  APPOINTMENT_CONFIGURATION: {
    path: "/web/admin/configuracion-parametros-citas",
    title: "Configuración de parámetros de citas",
    code: "parameter_configuration",
  },
  APPOINTMENT_TICKETS: {
    path: "/web/admin/seguimiento-citas",
    title: "Seguimiento de citas",
    code: "tracking_dates",
  },
  COMPLAINTS: {
    path: "/web/admin/consulta-quejas-reclamos",
    title: "Consulta de Quejas y Reclamos",
    code: "claim_complain",
  },

  ADMIN_USERS: {
    path: "/web/admin/users",
    title: "Usuarios administradores",
    code: "claim_complain",
  },

  CREATE_COMPLAINTS: {
    path: "/web/admin/registro-quejas-reclamos",
    title: "Registro de Quejas y Reclamos",
    code: "claim_complain",
  },

  ADMIN_USERS_AGENT: {
    path: "/web/importaciones/users/agent",
    title: "Usuarios administradores",
    code: "claim_complain",
  },
  SYNC_DATA: {
    path: "/web/admin/sincronizar-datos",
    title: "Sincronización manual para facturación",
    code: "sync_data_manual",
  },
  BILLING_USERS_ADMIN: {
    path: "/web/admin/facturacion",
    title: "Facturación",
  },
  PAYMENT: {
    path: "/web/admin/facturacion/pagos",
    title: "Pagos",
  },
  PAYMENT_INVOICES: {
    path: "/web/admin/facturacion/pagos/facturados",
    title: "Pagos",
  },
  ORDERS: {
    path: "/web/admin/facturacion/pedidos",
    title: "Pedidos",
  },
  REPORTS: {
    path: "/web/admin/reportes",
    title: "Reportes",
  },
};

export const USER_ROUTES = {
  IMPORTS: {
    path: "/web/importaciones",
    title: "Importaciones",
  },
  BILLING_USERS_AGENT: {
    path: "/web/importaciones/facturacion",
    title: "Facturación",
  },
  ORDERS: {
    path: "/web/importaciones/facturacion/pedidos",
    title: "Pedidos",
  },
  PAYMENT: {
    path: "/web/importaciones/facturacion/pagos",
    title: "Pagos",
  },
  DATES: {
    path: "/web/importaciones/facturacion/citas",
    title: "Cita",
  },
  DOCUMENT_VALIDATION: {
    path: "/web/importaciones/validacion-documentos",
    title: "Gestión de validaciones",
  },
  CHATBOT: {
    path: "/web/importaciones/chat",
    title: "Chatbot",
  },
  COMPLAINTS: {
    path: "/web/importaciones/consulta-quejas-reclamos",
    title: "Consulta Queja/Reclamo",
  },
  CREATE_COMPLAINTS: {
    path: "/web/importaciones/registro-quejas-reclamos",
    title: "Registro Queja/Reclamo",
  },
  USER_AGENT: {
    path: "/web/importaciones/usuarios",
    title: "Usuarios",
  },
  CREATE_QUOTES: {
    path: "/web/importaciones/facturacion/citas/creacion",
    title: "Creación de citas",
  },
  DATING_TRACKING: {
    path: "/web/importaciones/facturacion/citas/seguimiento",
    title: "Seguimiento de citas",
  },
  PAYMENT_PRE_BILLS: {
    path: "/web/importaciones/facturacion/pagos/prefacturas",
    title: "Pre facturas",
  },
  PAYMENT_VALIDATION_STATUS: {
    path: "/web/importaciones/facturacion/pagos/estadoValidaciones",
    title: "Estado de validación",
  },
  CREATING_QUOTES: {
    path: "/web/importaciones/facturacion/citas/creacion",
    title: "Creación de citas",
  },
  INVOICED_PAYMENTS: {
    path: "/web/importaciones/facturacion/pagos/facturados",
    title: "Facturados",
  },
};
